import Three from "../component/threesection/three";
import Cards from "../component/cards/card"

import Company from "../component/company/compnay"
function About(){
    return(
        <>
        <Company/>
        <Cards/>
        <Three/>
        </>
    )
}
export default About